module.exports =
  base: '/ping'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/ping.coffee